import { sortLegsByDate } from 'utils/sortLegsByDate';
import { types } from 'types/passengers';

export const findEarliest = (legs) => {
  if (legs && legs.length <= 0) {
    return null;
  }

  const [{ timing }] = [...legs].sort(sortLegsByDate);

  return timing.date;
};

export const findEarliestLeg = (legs) => {
  if (legs && legs.length <= 0) {
    return null;
  }

  return [...legs].sort(sortLegsByDate)[0];
};

const buildPassengersOfType = (type, disabilityType, count, startIndex = 0) =>
  Array(count)
    .fill({ type, disabilityType })
    .map((value, index) => ({
      id: `passenger_${index + startIndex}`,
      ...value
    }));

export const buildPassengers = ({ booking, adults }) => {
  const index = booking.passengers.length + 1;

  return buildPassengersOfType('AD', types.NO_HANDICAP, adults, index);
};
